export default function defaultBlankString<N>(string: string | null | undefined, def: N): string | N {
  return string?.trim() || def;
}
